/**
 * shared.module.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

// support components
import { CommentListComponent } from "../intake-form/comment-list.component";
import { CheckboxListValueAccessor }
  from "../support/APIs/checkbox-list-value-accessor";
import { DateValueAccessor }
  from "../support/APIs/date-value-accessor";
import { DatetimeValueAccessor }
  from "../support/APIs/datetime-value-accessor";
import { AutosizeDirective } from "../support/controls/autosize.directive";
import { BooleanPillComponent }
  from "../support/controls/boolean-pill.component";
import { CountdownComponent } from "../support/controls/countdown.component";
import { GroupValidationComponent }
  from "../support/controls/group-validation.component";
import { MatchFrameContentHeightDirective }
  from "../support/controls/match-frame-content-height.directive";
import { MembershipInputComponent }
  from "../support/controls/membership-input.component";
import { ValidationMessagesComponent }
  from "../support/controls/validation-messages.component";
import { PagerComponent } from "../support/pager.component";
import { RepeatToDirective } from "../support/utilities/repeat-to.directive";

// data interaction components
import { ControlGroupComponent }
  from "../common/data/control-group.component";
import { CopyableLiteralComponent }
  from "../common/data/copyable-literal.component";
import { DataSortingHeaderComponent }
  from "../common/data/data-sorting-header.component";
import { TypedControlComponent }
  from "../common/data/typed-control.component";
import { TypedDisplayComponent }
  from "../common/data/typed-display.component";
import { TypedFieldComponent }
  from "../common/data/typed-field.component";

// data visualization components
import { ForceDirectedGraphComponent }
  from "../graphs/force-directed-graph.component";
import { FrequencyChartComponent }
  from "../graphs/frequency-chart.component";

// miscellaneous
import { PreauthAwareRouterLink }
  from "../auth/preauth-aware-router-link.directive";
import { SpinnerComponent } from "../common/spinner.component";

// 3rd party
import { PrettyJsonComponent } from "angular2-prettyjson";

const COMPONENTS : any[] = [
    BooleanPillComponent,
    CheckboxListValueAccessor,
    CommentListComponent,
    ControlGroupComponent,
    CountdownComponent,
    CopyableLiteralComponent,
    DataSortingHeaderComponent,
    DateValueAccessor,
    DatetimeValueAccessor,
    ForceDirectedGraphComponent,
    FrequencyChartComponent,
    GroupValidationComponent,
    MembershipInputComponent,
    PagerComponent,
    PreauthAwareRouterLink,
    PrettyJsonComponent,
    SpinnerComponent,
    TypedControlComponent,
    TypedDisplayComponent,
    TypedFieldComponent,
    ValidationMessagesComponent,
];

const DIRECTIVES : any[] = [
    AutosizeDirective,
    MatchFrameContentHeightDirective,
    RepeatToDirective
];

// PIPES

import { PrettyJsonPipe } from "angular2-prettyjson/index";
import { ArraySegmentsPipe } from "../support/pipes/array-segments.pipe";
import { BytesPipe } from "../support/pipes/bytes.pipe";
import { CalendarTimePipe } from "../support/pipes/calendar-time.pipe";
import { JoinPipe } from "../support/pipes/join.pipe";
import { EntriesPipe, KeysPipe } from "../support/pipes/keys.pipe";
import { OrdinalPipe } from "../support/pipes/ordinal.pipe";
import { PageQueryPipe, PaginationPipe } from "../support/pipes/paginate.pipe";
import { PercentagePipe } from "../support/pipes/percentage.pipe";
import { PluralizationPipe } from "../support/pipes/plural.pipe";
import { ReversePipe } from "../support/pipes/reverse.pipe";
import { SquashIndicesPipe } from "../support/pipes/squash-indices.pipe";
import { ThousandsPipe } from "../support/pipes/thousands.pipe";
import { FlagifyPipe, UnicodeOffsetPipe }
  from "../support/pipes/unicode-offset.pipe";
import { UtcDatePipe } from "../support/pipes/utc-date.pipe";
import { UnsafePipe } from "../support/pipes/unsafe.pipe";

const PIPES : any[] = [
  ArraySegmentsPipe,
  BytesPipe,
  CalendarTimePipe,
  EntriesPipe,
  FlagifyPipe,
  JoinPipe,
  KeysPipe,
  OrdinalPipe,
  PageQueryPipe,
  PaginationPipe,
  PercentagePipe,
  PluralizationPipe,
  PrettyJsonPipe,
  ReversePipe,
  SquashIndicesPipe,
  ThousandsPipe,
  UnicodeOffsetPipe,
  UnsafePipe,
  UtcDatePipe
];

@NgModule({
    imports: [ CommonModule, ReactiveFormsModule, HttpModule],
    declarations: [ COMPONENTS, DIRECTIVES, PIPES ],
    exports: [
        CommonModule,
        HttpModule,
        ReactiveFormsModule,
        COMPONENTS,
        DIRECTIVES,
        PIPES
    ]
 })
export class SharedModule {
    // public static forRoot () : ModuleWithProviders
    // {
    //     return {
    //         ngModule: AggregationModule,
    //         providers: [AggregationService]
    //     };
    // }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/shared/shared.module.ts